import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';

import {
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../../core/core.module';
import { State } from '../../../../vista-usuario/vista-usuario.state';

import { ActivatedRoute, Router } from '@angular/router';

import {
  selectAllEntidadesProductiva,
  selectEntidadesProductivaRolesPropios
} from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import { selectAllPersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.selectors';
import { selectAllPersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.selectors';

import { entityCurrentEmpresaLoadRequest } from '../../entity-current-empresa.actions';
import {
  EntidadesProductiva,
  EntidadesProductivaNombrePFoJ
} from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { PersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.model';
import {
  PersonasJuridica,
  RPEPersonaJuridica
} from '../../../entity-personas-juridica/entity-personas-juridica.model';

import { CurrentEmpresa } from '@rpe/registro-personas-empresas-lib';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { selectAllPersonas } from '../../../../persona/entity-personas/entity-personas.selectors';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import {
  selectRolesPropios,
  selectRolesPropiosByEntidadProductivaId
} from '../../../../roles/entity-roles/entity-roles.selectors';
import { Rol } from '../../../../roles/entity-roles/roles.model';
import {
  selectAcreditacionEmpresaByEntidadProductiva,
  selectAllEntityAcreditacionEmpresa
} from '../../../acreditacion-empresa/entity-acreditacion-empresa.selectors';
import { EntityAcreditacionEmpresa } from '../../../acreditacion-empresa/entity-acreditacion-empresa.model';

@Component({
  selector: 'rpe-entity-mis-empresas-form-container',
  templateUrl: './entity-mis-empresas-form-container.component.html',
  styleUrls: ['./entity-mis-empresas-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityMisEmpresasFormContainerComponent
  implements OnInit, OnDestroy
{
  returnRouteCompleteRegister = `/empresas/registro-empresa?continuar=true`;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  listaEmpresaSubscription: Subscription;
  rolesSubscription: Subscription;
  acreditacionSubscription: Subscription;

  //tengo un mapa con clave el nombre de la empresa y el valor seria la entidadproductiva

  listaEmpresasSubject: BehaviorSubject<EntidadesProductivaNombrePFoJ[]> =
    new BehaviorSubject<EntidadesProductivaNombrePFoJ[]>([]);

  entidadesProductivas: EntidadesProductiva[] | undefined;
  personasFisica: PersonasFisica[] | undefined;
  personasJuridica: PersonasJuridica[] | undefined;
  personas: Persona[] | undefined;
  listaEmpresas: EntidadesProductivaNombrePFoJ[] = [];
  authPersonaRoles: Rol[] = [];
  acreditaciones: EntityAcreditacionEmpresa[];
  acreditacionUrl: boolean;

  formValid: boolean = false;
  formValue: RPEPersonaJuridica;
  tipoPersonaEmpresa: string = 'persona_juridica';

  returnRoute = '/empresas/mi-empresa';

  constructor(
    public store: Store<State>,
    private ref: ChangeDetectorRef,
    private readonly notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const retUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.acreditacionUrl =
      this.route.snapshot.queryParamMap.has('returnUrl') &&
      this.route.snapshot.queryParamMap
        .get('returnUrl')
        ?.includes('acreditacion-empresa');
    if (retUrl) {
      this.returnRoute = retUrl;
    }

    this.store
      .pipe(select(selectAllPersonasFisica))
      .subscribe((personasFisica) => {
        this.personasFisica = personasFisica;
        this.store
          .pipe(select(selectAllPersonasJuridica))
          .subscribe((personasJuridica) => {
            this.personasJuridica = personasJuridica;
            this.store
              .pipe(select(selectEntidadesProductivaRolesPropios))
              .subscribe((entidadesProductivas) => {
                this.entidadesProductivas = entidadesProductivas;
                this.store
                  .pipe(select(selectAllPersonas))
                  .subscribe((personas) => {
                    this.personas = personas;

                    //tenemos entidades productivas hay que ver para cada una si es PF o PJ y si es de la persona
                    let empresa: EntidadesProductivaNombrePFoJ;
                    console.log(this.entidadesProductivas);

                    this.entidadesProductivas?.forEach((eP) => {
                      if (eP.estado === 3 && eP.persona_fisica_id) {
                        let PFFilter = this.personasFisica.find(
                          (pf) => pf.id == eP.persona_fisica_id
                        );

                        let pFilter = personas.find((p) => {
                          return PFFilter.persona_id == p.id;
                        });

                        empresa = {
                          idEntidadProductiva: eP.id,
                          nombrePersonaFoJ: pFilter?.nombre_completo
                        };

                        this.listaEmpresas.push(empresa);
                      }

                      if (eP.estado === 3 && eP.persona_juridica_id) {
                        let PJFilter = this.personasJuridica.find(
                          (pj) => pj.id == eP.persona_juridica_id
                        );

                        empresa = {
                          idEntidadProductiva: eP.id,
                          nombrePersonaFoJ: PJFilter?.denominacion_social
                        };

                        this.listaEmpresas.push(empresa);
                      }
                    });

                    this.listaEmpresasSubject.next(this.listaEmpresas);
                  });
              });
          });
      });

    this.listaEmpresaSubscription = this.listaEmpresasSubject
      .asObservable()
      .pipe(
        map((listaEmpresas) => {
          return listaEmpresas.sort((a, b) => {
            if (a.nombrePersonaFoJ < b.nombrePersonaFoJ) {
              return -1;
            }
            if (a.nombrePersonaFoJ > b.nombrePersonaFoJ) {
              return 1;
            }
            return 0;
          });
        }),
        tap((listaEmpresas) => {
          this.listaEmpresas = listaEmpresas;
          this.ref.markForCheck();
        })
      )
      .subscribe();

    this.rolesSubscription = this.store
      .pipe(select(selectRolesPropios))
      .subscribe((roles) => (this.authPersonaRoles = roles));

    this.acreditacionSubscription = this.store
      .pipe(select(selectAllEntityAcreditacionEmpresa))
      .subscribe((acreditaciones) => (this.acreditaciones = acreditaciones));
  }

  onSelectEmpresa(empresa: EntidadesProductivaNombrePFoJ) {
    let auxCE: CurrentEmpresa = {
      nombre: empresa.nombrePersonaFoJ,
      id: empresa.idEntidadProductiva
    };

    const entidadConEstado1 = this.entidadesProductivas.find((entidad) => {
      return entidad.id === empresa.idEntidadProductiva && entidad.estado === 1;
    });

    this.store.dispatch(
      entityCurrentEmpresaLoadRequest({
        item: auxCE
      })
    );

    if (entidadConEstado1) {
      this.router.navigateByUrl(this.returnRouteCompleteRegister);
    } else {
      this.router.navigate([this.returnRoute]);
    }
  }

  ngOnDestroy(): void {
    this.listaEmpresaSubscription.unsubscribe();

    if (this.rolesSubscription) {
      this.rolesSubscription.unsubscribe();
    }

    if (this.acreditacionSubscription) {
      this.acreditacionSubscription.unsubscribe();
    }
  }

  disableButton(empresaId: number): boolean {
    if (this.acreditacionUrl) {
      if (this.entidadProductivaById(empresaId).estado != 3) {
        return true;
      }

      if (!this.findTrHabilitado(empresaId)) {
        return true;
      }

      if (!this.findResponsableEmpresa()) {
        return true;
      }

      if (this.findAcreditacionSolicitada(empresaId)) {
        return true;
      }

      return false;
    } else {
      return false;
    }
  }

  entidadProductivaById(entidadProductivaId: number) {
    const entidad = this.entidadesProductivas.find(
      (e) => e.id === entidadProductivaId
    );
    return entidad;
  }

  findTrHabilitado(entidadProductivaId: number): boolean {
    const currentRolesOfEntidadProductiva = this.authPersonaRoles;
    const trHabilitado = currentRolesOfEntidadProductiva.find((rol) => {
      return (
        rol.tipo_rol_id === 6 &&
        !rol.fecha_baja &&
        rol.vinculo_aprobado_entidad_productiva &&
        rol.vinculo_aprobado_rol &&
        rol.entidad_productiva_id === entidadProductivaId
      );
    });

    return !!trHabilitado;
  }

  findResponsableEmpresa(): boolean {
    const responsableEmpresa = this.authPersonaRoles.find((rol) => {
      return (
        rol.tipo_rol_id <= 6 &&
        !rol.fecha_baja &&
        rol.vinculo_aprobado_entidad_productiva &&
        rol.vinculo_aprobado_rol
      );
    });

    return responsableEmpresa ? true : false;
  }

  findAcreditacionSolicitada(empresaId: number): boolean {
    const acreditacionEmpresa = this.acreditaciones.find((acreditacion) => {
      return acreditacion.entidad_productiva_id === empresaId;
    });

    return acreditacionEmpresa?.estado_acreditacion_id === 2;
  }
}
